var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-tabs',{attrs:{"align":"left"}},_vm._l((_vm.tabs),function(tab,index){return _c('b-tab',{key:tab.role,attrs:{"title":tab.title,"active":index == 0,"lazy":""}},[_c('table-dynamic-user-role',{attrs:{"tab":tab}})],1)}),1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }